/* tslint:disable */
import {
  PropertyUnits,
  PropertyType,
  Country,
  UserProfile,
  PropertyDetails
} from '../index';

declare var Object: any;
export interface CompanyAccountInterface {
  "property_name": string;
  "estate_name"?: string;
  "street_name": string;
  "town_city"?: string;
  "country_id"?: number;
  "property_status"?: string;
  "company_role": string;
  "vat_percentage"?: number;
  "settings"?: any;
  "pay_bill"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "property_type_id"?: number;
  propertyUnits?: PropertyUnits[];
  propertyType?: PropertyType;
  country?: Country;
  userProfiles?: UserProfile[];
  tenants?: UserProfile[];
  propertyTypes?: PropertyType[];
  propertyDetails?: PropertyDetails;
  landLords?: UserProfile[];
}

export class CompanyAccount implements CompanyAccountInterface {
  "property_name": string;
  "estate_name": string;
  "street_name": string;
  "town_city": string;
  "country_id": number;
  "property_status": string;
  "company_role": string;
  "vat_percentage": number;
  "settings": any;
  "pay_bill": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "property_type_id": number;
  propertyUnits: PropertyUnits[];
  propertyType: PropertyType;
  country: Country;
  userProfiles: UserProfile[];
  tenants: UserProfile[];
  propertyTypes: PropertyType[];
  propertyDetails: PropertyDetails;
  landLords: UserProfile[];
  constructor(data?: CompanyAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CompanyAccount`.
   */
  public static getModelName() {
    return "CompanyAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CompanyAccount for dynamic purposes.
  **/
  public static factory(data: CompanyAccountInterface): CompanyAccount{
    return new CompanyAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CompanyAccount',
      plural: 'CompanyAccounts',
      path: 'CompanyAccounts',
      idName: 'id',
      properties: {
        "property_name": {
          name: 'property_name',
          type: 'string'
        },
        "estate_name": {
          name: 'estate_name',
          type: 'string'
        },
        "street_name": {
          name: 'street_name',
          type: 'string'
        },
        "town_city": {
          name: 'town_city',
          type: 'string'
        },
        "country_id": {
          name: 'country_id',
          type: 'number'
        },
        "property_status": {
          name: 'property_status',
          type: 'string'
        },
        "company_role": {
          name: 'company_role',
          type: 'string',
          default: 'PROPERTY'
        },
        "vat_percentage": {
          name: 'vat_percentage',
          type: 'number',
          default: 0
        },
        "settings": {
          name: 'settings',
          type: 'any',
          default: <any>null
        },
        "pay_bill": {
          name: 'pay_bill',
          type: 'string',
          default: ''
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "property_type_id": {
          name: 'property_type_id',
          type: 'number'
        },
      },
      relations: {
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits[]',
          model: 'PropertyUnits',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'property_id'
        },
        propertyType: {
          name: 'propertyType',
          type: 'PropertyType',
          model: 'PropertyType',
          relationType: 'belongsTo',
                  keyFrom: 'property_type_id',
          keyTo: 'id'
        },
        country: {
          name: 'country',
          type: 'Country',
          model: 'Country',
          relationType: 'belongsTo',
                  keyFrom: 'country_id',
          keyTo: 'id'
        },
        userProfiles: {
          name: 'userProfiles',
          type: 'UserProfile[]',
          model: 'UserProfile',
          relationType: 'hasMany',
          modelThrough: 'PropertyOwner',
          keyThrough: 'property_owner_id',
          keyFrom: 'id',
          keyTo: 'property_id'
        },
        tenants: {
          name: 'tenants',
          type: 'UserProfile[]',
          model: 'UserProfile',
          relationType: 'hasMany',
          modelThrough: 'TenantUnit',
          keyThrough: 'tenant_id',
          keyFrom: 'id',
          keyTo: 'property_id'
        },
        propertyTypes: {
          name: 'propertyTypes',
          type: 'PropertyType[]',
          model: 'PropertyType',
          relationType: 'hasMany',
          modelThrough: 'PropertyPropertyType',
          keyThrough: 'property_type_id',
          keyFrom: 'id',
          keyTo: 'property_id'
        },
        propertyDetails: {
          name: 'propertyDetails',
          type: 'PropertyDetails',
          model: 'PropertyDetails',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'property_id'
        },
        landLords: {
          name: 'landLords',
          type: 'UserProfile[]',
          model: 'UserProfile',
          relationType: 'hasMany',
          modelThrough: 'LandlordProperties',
          keyThrough: 'land_lord_id',
          keyFrom: 'id',
          keyTo: 'property_id'
        },
      }
    }
  }
}
